<template>
    <el-input v-bind="$attrs" v-model="modelValue">
        <template #suffix>
            <span @click="handleClick" class="code">{{
                $attrs.text
            }}</span>
        </template>
    </el-input>
</template>

<script>
export default {
    name: "loginPhoneInput",
    data() {
        return {
            a: "我是验证码",
        };
    },
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
    },
    computed: {
        modelValue: {
            get({ value, $attrs }) {
                if ($attrs.multiple && !Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        handleClick() {
            this.$emit("getCode", this.a);
        },
    },
};
</script>

<style lang="scss" scoped>
.code {
    color: $defaultColor;
}
</style>